export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  // BASE_HOME = '/socialSecurityHead',
  BASE_HOME = '/home/index',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  REGISTER = '/register',
  ENTRY = '/accept/entry',
  // DETAIL_APPROVAL='/detail/approval',
  // BASE_CENTER='/center/index',
  // BASE_NOTICE='/notice/index'
}
